import { asyncFetch } from './request.js';
import OSS from 'ali-oss';

// 获取临时授权
const getCredit = function(fileType) {
    return asyncFetch({
        url: `/v1/oss/getCredit/${fileType}`,
        method: 'get',
        mode: 'cors',
        headers: {
            'x-oss-forbid-overwrite': true
        }
    });
};

// 获取临时授权-上传图片
const getMlCredit = function(projectId, projectlabel) {
    if (projectlabel) {
        return asyncFetch({
            url: `/v1/oss/getMlCredit/${projectId}?label=${projectlabel}`,
            method: 'get',
            mode: 'cors',
            // params: {
            //     label: projectlabel
            // },
            headers: {
                'x-oss-forbid-overwrite': true
            }
        });
    } else {
        return asyncFetch({
            url: `/v1/oss/getMlCredit/${projectId}`,
            method: 'get',
            mode: 'cors',
            headers: {
                'x-oss-forbid-overwrite': true
            },
            // params: {
            //     label: projectlabel
            // },
        });
    }
};

const dataURLtoBlob = function(dataUrl) {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bStr = atob(arr[1]);
    let n = bStr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bStr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
};

const OssClient = function(res, fileType) {
    return new OSS({
        endpoint: 'https://static.matatalab.com',
        region: 'oss-cn-shenzhen',
        accessKeyId: res.accessKeyId,
        accessKeySecret: res.accessKeySecret,
        bucket: res.bucket,
        expiration: res.expiration,
        stsToken: res.securityToken,
        secure: true,
        cname: true,
        refreshSTSToken: () => {
            let refreshToken;
            if (fileType === 'ml') {
                refreshToken = getMlCredit({
                    headers: {
                        'x-oss-forbid-overwrite': true
                    }
                });
            } else {
                refreshToken = getCredit({
                    headers: {
                        'x-oss-forbid-overwrite': true
                    },
                    fileType: fileType || 'img'
                });
            }
            return {
                accessKeyId: refreshToken.AccessKeyId,
                accessKeySecret: refreshToken.AccessKeySecret,
                stsToken: refreshToken.SecurityToken,
                expiration: refreshToken.expiration
            };
        }
    });
};

const uploadOss = function(
    fileType,
    file,
    projectId,
    type,
    projectlabel,
    progressHandle,
    callBack,
    errorHandle
) {
    // let res = res = getCredit(data);
    let res = null;
    if (type === 'cams') {
        res = getMlCredit(projectId, projectlabel);
    } else {
        res = getCredit(fileType);
    }
    if (res.code === 200) {
        // console.log(res);
        const basePath = res.data.basePath;
        const ossOptions = OssClient(res.data, fileType);
        let headers = {};

        if (file.name.includes('.mp4')) {
            headers = {
                'Content-Type': 'video/mp4'
            };
        }
        if (file.size > 1024 * 1024 * 100) {
            ossOptions
                .multipartUpload(`${basePath}/${file.name}`, file, {
                    progress: function(p) {
                        progressHandle && progressHandle(p);
                        console.log(p);
                    },
                    headers: headers
                })
                .then(resOss => {
                    // console.log(resOss, 'resOss');
                    resOss.completeMultipartUpload(
                        `${basePath}/${file.name}`,
                        res.headers['x-oss-request-id']
                    );
                    // console.log(resOss.res.requestUrls[0]);
                    console.log(resOss);
                    callBack(resOss.res.requestUrls[0]);
                })
                .catch(err => {
                    console.log(err);
                    errorHandle && errorHandle(err);
                });
        } else {
            // console.log(file, 'file');
            ossOptions
                .put(`${basePath}/${file.name}`, file, {
                    progress: progressHandle,
                    headers: headers
                })
                .then(resOss => {
                    // console.log(resOss, 'resOss');
                    // console.log(resOss.res.requestUrls[0]);
                    callBack(resOss.res.requestUrls[0]);
                })
                .catch(err => {
                    console.log(err);
                    errorHandle && errorHandle(err);
                });
        }
        // return resOss.res.requestUrls[0];
    } else {
        console.log(res, 'resres')
        errorHandle && errorHandle(res);
    }
};

// 创建删除文件的方法
const deleteFileFromOSS = function(
    fileType,
    projectlabel,
    projectId,
    type,
    fileKey
) {
    let res = null;
    if (type === 'cams') {
        res = getMlCredit(projectId, projectlabel);
    } else {
        res = getCredit(fileType);
    }
    if (res.code === 200) {
        // console.log(res);
        const basePath = res.data.basePath;
        const ossOptions = OssClient(res.data, fileType);

        // 调用 OSS 客户端的 delete 方法删除文件
        return ossOptions
            .delete(`${basePath}/${fileKey}`)
            .then(
                result =>
                // console.log(`文件 ${fileKey} 删除成功`);
                result
            )
            .catch(err => {
                console.error(`删除文件 ${fileKey} 失败: ${err}`);
            });
    }
};

// 批量删除文件的方法
const deleteBatchFilesFromOSS = async function(
    fileType,
    projectlabel,
    projectId,
    type,
    fileKey
) {
    let res = null;
    if (type === 'cams') {
        res = getMlCredit(projectId, projectlabel);
    } else {
        res = getCredit(fileType);
    }
    if (res.code === 200) {
        // console.log(res);
        const basePath = res.data.basePath;
        const ossOptions = OssClient(res.data, fileType);

        // console.log(basePath, 'basePath');
        // 调用 OSS 客户端的 删除多个文件。
        return ossOptions
            .list({ prefix: basePath })
            .then(result => {
                const data = result.objects || [];
                // console.log(data, 'result');
                // console.log(`文件 ${basePath} 删除成功`);
                return data.map(v => {
                    ossOptions
                        .delete(v.name)
                        .then(
                            result =>
                            // console.log(`文件 ${v.name} 删除成功`);
                            result
                        )
                        .catch(err => {
                            console.error(`删除文件 ${v.name} 失败: ${err}`);
                        });
                });
            })
            .catch(err => {
                console.error(`删除文件 ${basePath} 失败: ${err}`);
            });
    }
};

// 修改classl类导致文件目录也需要修改
const updateFileFromOSS = function(
    fileType,
    projectlabelNew,
    projectlabelOld,
    projectId,
    type,
    callBack
) {
    let res = null;
    let resOld = null;
    let resNew = null;
    let resUrl = []
    if (type === 'cams') {
        resOld = getMlCredit(projectId, projectlabelOld);
        resNew = getMlCredit(projectId, projectlabelNew);
    } else {
        res = getCredit(fileType);
    }
    if (resOld.code === 200 || resNew.code === 200) {
        const basePathOld = resOld.data.basePath;
        const basePathNew = resNew.data.basePath;
        const ossOptions = OssClient(resOld.data, fileType);
        return ossOptions
            .list({ prefix: basePathOld })
            .then(result => {
                const data = result.objects || [];
                // console.log(data, basePathOld, basePathNew, 'result');

                return data.map(v => {
                    const fileName = v.name.match(/\/([^/]+)$/)[1];
                    ossOptions
                        .copy(`${basePathNew}/${fileName}`, `${basePathOld}/${fileName}`)
                        .then(
                            result => {
                                // 删除旧地址。
                                ossOptions.delete(`${basePathOld}/${fileName}`).then(j => {
                                    // console.log(j);
                                    // console.log(`文件 ${basePathOld}/${fileName} 删除成功`)
                                });
                                console.log(`文件 ${basePathNew}/${fileName} 拷贝成功`)
                                resUrl.push(result.res.requestUrls[0])
                                callBack(resUrl);
                            }
                        )
                        .catch(err => {
                            console.error(`修改文件 ${v.name} 失败: ${err}`);
                        });
                });
            })
            .catch(err => {
                console.error(`修改文件 ${basePath} 失败: ${err}`);
            });
    }
};

export { getCredit, uploadOss, deleteFileFromOSS, deleteBatchFilesFromOSS, updateFileFromOSS };